export enum SiteIdEnum {
    SITE_ID = 7,
    EDU_SITE_ID = 6,
    AI_SITE_ID = 14,
}
